import {Injectable} from '@angular/core';
import {StageService} from './stage.service';
import {ProjectManagerService} from './project-manager.service';
import {AppSettingsService} from './app-settings.service';
import {EnvLoader} from '../classes/EnvLoader';
import {Subject} from 'rxjs/Subject';
import {EnvironmentScenarioBase, Urban, Beach, Lakefront, Winter} from '../custom/env/scenarios';
import {Interval} from '../classes/Matm';
import {SceneLoadingService} from './scene-loading.service';

declare var THREE: any;

@Injectable()
export class SceneryService {

  private envLoader: EnvLoader;
  private baseEnvPath = '../../assets/environments/';
  wnd = window as any;
  public readonly onChange: Subject<any>;
  private cubemapTexture;
  public readonly changeSelectedToMenu: Subject<any>;
  private currentEnvName;
  private env: EnvironmentScenarioBase;
  private currentDayLightValue: Interval | undefined;

  private mapping = {
    'urban': Urban,
    'beach': Beach,
    'lakefront': Lakefront,
    'winter': Winter
  };

  constructor(
    private stage: StageService,
    private appSettingsService: AppSettingsService,
    private projectSrvc: ProjectManagerService,
    private sceneLoadingService: SceneLoadingService
  ) {

    this.onChange = new Subject<any>();
    this.envLoader = new EnvLoader(this.baseEnvPath, this.transformScene);
    this.changeSelectedToMenu = new Subject<any>();

    this.wnd.sc = this.stage.scene;
  }

  private switch(env) {
    const old = this.stage.getObjectByName('environment');
    if (old) {
      this.stage.remove(old);
    }
    this.stage.add(env);
    
    // Уведомляем SceneLoadingService о загрузке окружения
    setTimeout(() => {
      this.sceneLoadingService.forceCheck();
    }, 100);
  }

  private transformScene = (scene, name) => this.mapping[name] ? new this.mapping[name](scene) : scene;

  async change(name: string): Promise<any> {
    const env = await this.envLoader.load(name) as EnvironmentScenarioBase;
    this.changeSelectedToMenu.next(name);
    if (this.currentEnvName === name) {
      return env;
    }
    this.switch(env);
    if (this.currentDayLightValue) {
      env.setDayLight(this.currentDayLightValue);
    }
    this.projectSrvc.setScenery(name);
    this.appSettingsService.setScenery(name);
    this.onChange.next(env);
    this.currentEnvName = name;
    this.env = env;
    return env;
  }

  setDayLight(interval: Interval) {
    this.currentDayLightValue = interval;
    this.env.setDayLight(interval);
  }

  cubeMap() {
    if (!this.cubemapTexture) {
      const urban = [
        'grass2/posX.jpg',
        'grass2/negX.jpg',
        'grass2/posY.jpg',
        'grass2/negY.jpg',
        'grass2/posZ.jpg',
        'grass2/negZ.jpg'
      ];
      this.cubemapTexture = new THREE.CubeTextureLoader()
        .setPath('../../assets/environments/')
        .load(urban);
    }
    return this.cubemapTexture;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/scenery.service.ts